import { render, staticRenderFns } from "./Asesores.vue?vue&type=template&id=50a1dd08&scoped=true"
import script from "./Asesores.vue?vue&type=script&lang=js"
export * from "./Asesores.vue?vue&type=script&lang=js"
import style0 from "./Asesores.vue?vue&type=style&index=0&id=50a1dd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1dd08",
  null
  
)

export default component.exports